var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityGasSupply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -968.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Gas-supply",
    transform: "translate(2734.000000, 968.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0012272,30 C13.5109922,30 11.5008024,28.02 11.5008024,25.58 C11.5008024,23.14 16.0012272,17 16.0012272,17 C16.0012272,17 20.5016521,23.14 20.5016521,25.58 C20.5016521,28.02 18.4814614,30 16.0012272,30 M27.132278,14.91 C26.1521854,13.61 24.9020674,12.52 23.4619315,11.75 C19.791585,9.8 17.3113509,5.85 17.3113509,1.47 L17.3113509,0 C13.0809516,1.92 10.150675,7.23 10.150675,12.08 L10.150675,17.07 C8.80054754,15.36 7.79045219,13.13 7.51042576,10.89 C4.76016615,13.2 3.0900085,16.36 3,19.8 L3,20 C3.42003965,26.81 9.22058719,32 16.2912546,32 C18.36145,32 20.3016332,31.48 22.0317965,30.59 C23.7619598,29.7 25.2821033,28.45 26.5122194,27 C29.4925007,23.48 29.9125404,18.59 27.132278,14.91",
    id: 71
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityGasSupply);
export default __webpack_public_path__ + "static/media/transport-and-utility-gas-supply.ac100c65.svg";
export { ForwardRef as ReactComponent };